// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pg7yhRjb__RegistrationFormSkeleton__styles-module__container___Xt1y9BeMacMpIWjA {
    width: 100%;
}

.pg7yhRjb__RegistrationFormSkeleton__styles-module__fieldWrap___mzHM5g3ytucyO_V2 {
    margin-bottom: 1.5rem;
}

.pg7yhRjb__RegistrationFormSkeleton__styles-module__label___lgUSNTkwnIFC0B68 {
    width: 30%;
    height: 0.75rem;
    margin-bottom: 0.375rem;
}

.pg7yhRjb__RegistrationFormSkeleton__styles-module__input___FzYRmDQr5grBox7m {
    width: 100%;
    height: 2rem;
}

.pg7yhRjb__RegistrationFormSkeleton__styles-module__checkbox___h2X56FBaIQRCnA6V {
    width: 70%;
    height: 1.125rem;
    margin-bottom: 1.5rem;
}

.pg7yhRjb__RegistrationFormSkeleton__styles-module__button___JnQOEjUkiw1roJH6 {
    width: 100%;
    height: 3.25rem;
    margin-bottom: 1.5rem;
}

.pg7yhRjb__RegistrationFormSkeleton__styles-module__divider___suM6PYwftAQtOw9C {
    width: 8%;
    height: 1rem;
    margin: 0 auto 1.5rem;
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/modules/registrationForm/components/RegistrationFormSkeleton/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":[".container {\n    width: 100%;\n}\n\n.fieldWrap {\n    margin-bottom: 1.5rem;\n}\n\n.label {\n    width: 30%;\n    height: 0.75rem;\n    margin-bottom: 0.375rem;\n}\n\n.input {\n    width: 100%;\n    height: 2rem;\n}\n\n.checkbox {\n    width: 70%;\n    height: 1.125rem;\n    margin-bottom: 1.5rem;\n}\n\n.button {\n    width: 100%;\n    height: 3.25rem;\n    margin-bottom: 1.5rem;\n}\n\n.divider {\n    width: 8%;\n    height: 1rem;\n    margin: 0 auto 1.5rem;\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `pg7yhRjb__RegistrationFormSkeleton__styles-module__container___Xt1y9BeMacMpIWjA`;
export var fieldWrap = `pg7yhRjb__RegistrationFormSkeleton__styles-module__fieldWrap___mzHM5g3ytucyO_V2`;
export var label = `pg7yhRjb__RegistrationFormSkeleton__styles-module__label___lgUSNTkwnIFC0B68`;
export var input = `pg7yhRjb__RegistrationFormSkeleton__styles-module__input___FzYRmDQr5grBox7m`;
export var checkbox = `pg7yhRjb__RegistrationFormSkeleton__styles-module__checkbox___h2X56FBaIQRCnA6V`;
export var button = `pg7yhRjb__RegistrationFormSkeleton__styles-module__button___JnQOEjUkiw1roJH6`;
export var divider = `pg7yhRjb__RegistrationFormSkeleton__styles-module__divider___suM6PYwftAQtOw9C`;
export default ___CSS_LOADER_EXPORT___;
